import './Entete.scss';

export default function Entete() {

  return(
    <header className="Entete">
        <h1>Mon pense-bête</h1>
        <img src="bete.png" alt="logo"/>
      </header>
  ) 
}